module.exports = __webpack_public_path__ + "img/btc_games_logo.6090d757.webp";